module.exports = __webpack_public_path__ + "static/media/qsvg1.7298aa8f.svg";